module.exports = __webpack_public_path__ + "img/2024_CellReports.715c0d57.png";